class CollectionFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.productGridId = "CollectionProductGrid";
    this.filterFormsId = "CollectionFiltersForm";
    this.sections = this.getSections();
    this.filterWrapper = document.querySelector("collection-filtering-form");
    this.filterDrawer = this.filterWrapper.querySelector(
      "#CollectionFiltersForm",
    );
    this.searchTemplate = document.querySelector("#main-body.search-template");
    this.collectionTemplate = document.querySelector(
      "#main-body.collection-template",
    );

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 100);

    this.querySelector("form").addEventListener("input", (event) => {
      document.querySelector(`#${this.productGridId}`).classList.add("loading");
      this.debouncedOnSubmit(event);
    });
    document
      .querySelector("[data-drawer-open-btn]")
      .addEventListener("click", this.handleDrawerOpen.bind(this));
    this.addDrawerListeners.bind(this);
    window.addEventListener("resize", this.addDrawerListeners.bind(this));
    window.addEventListener("popstate", this.onHistoryChange.bind(this));

    this.bindActiveFacetButtonEvents();
    this.onDropDownBlur();

    /* window.addEventListener("HP::refreshCollectionItems", (event) => {
      document.querySelector(`#${this.productGridId}`).classList.add("loading");

      this.sections.forEach((section) => {
        if (this.collectionTemplate) {
          const url = `${window.location.pathname}?section_id=${section.section}`;
          this.renderSectionFromFetch(url, section, event);
        }
      });
    }); */
  }

  onDropDownBlur() {
    const getDropDowns = document.querySelectorAll("details");

    for (let item of getDropDowns) {
      document.addEventListener("click", function (event) {
        var isClickInside = item.contains(event.target);

        if (!isClickInside) {
          //the click was outside the specifiedElement, close the dropdown
          item.removeAttribute("open");
        }
      });
    }
  }

  isHidden(el) {
    return el.offsetParent === null;
  }

  addDrawerListeners() {
    const drawerOpenBtn = document.querySelector("[data-drawer-open-btn]");

    this.filterDrawer.removeAttribute("role");
    this.filterDrawer.removeAttribute("aria-modal");

    if (window.innerWidth < 991) {
      this.filterDrawer.setAttribute("role", "dialog");
      this.filterDrawer.setAttribute("aria-modal", "true");
    }

    if (this.isHidden(drawerOpenBtn)) return;

    drawerOpenBtn.addEventListener("click", this.handleDrawerOpen);
  }

  handleDrawerOpen(e) {
    e.target.setAttribute("tabIndex", "-1");
    const drawerCloseBtn = this.querySelector("[data-drawer-close-btn]");

    this.filterWrapper.classList.add("is-open");
    document.body.classList.add("js-drawer-open-left", "js-drawer-open");
    this.trapFocus("main-collection-filters", true);
    drawerCloseBtn.addEventListener("click", this.handleDrawerClose.bind(this));

    document.addEventListener(
      "click",
      (e) => this.handleOffDrawerClick(e),
      true,
    );
  }

  handleOffDrawerClick(e) {
    // @todo: figure out why this method keeps getting called
    const isDrawerClick = this.filterDrawer.contains(e.target);

    if (!isDrawerClick) this.handleDrawerClose();
  }

  handleDrawerClose() {
    const filterBtn = document.querySelector("[data-drawer-open-btn]");

    document.body.classList.remove("js-drawer-open-left", "js-drawer-open");
    this.filterWrapper.classList.remove("is-open");

    filterBtn.setAttribute("tabIndex", "0");
    document.removeEventListener("click", this.handleOffDrawerClick, true);
  }

  trapFocus(slideout_id, is_initial_open) {
    const idString = `#${slideout_id}`;
    const menu = document.getElementById(slideout_id);
    const togglers = document.querySelectorAll(
      ".facets__disclosure, .collection-filters__sort",
    );
    const inputs = document.querySelectorAll(
      `${idString} input:not([type=hidden]), ${idString} button:not([tabindex="-1"]), ${idString} a:not([tabindex="-1"]), ${idString} textarea`,
    );
    // The first input will always stay the same so we'll declare it here
    const firstInput = inputs[0];
    let lastInput;

    menu.addEventListener("keydown", function (e) {
      const getLastToggler = togglers[togglers.length - 1];
      const lastGroupCollapsed = !getLastToggler.hasAttribute("open");

      // If the last tag list is collapsed, the toggle button becomes the 'last input'
      // else the last input is equal to the last input in the array
      lastInput = lastGroupCollapsed
        ? getLastToggler
        : inputs[inputs.length - 1];

      // Redirect last tab to first input
      if (
        e.code === "Tab" &&
        !e.shiftKey &&
        document.activeElement == lastInput
      ) {
        e.preventDefault();
        firstInput.focus();
      }

      // Redirect first shift+tab to last input
      if (
        e.code === "Tab" &&
        e.shiftKey &&
        document.activeElement == firstInput
      ) {
        e.preventDefault();
        lastInput.focus();
      }
    });
  }

  async onSubmitHandler(event) {
    console.log("event", event);
    event.preventDefault();

    const form = event.target.closest("form");
    const formData = new FormData(form);
    const searchParamsInitial = new URLSearchParams(window.location.search);

    if (this.collectionTemplate) {
      const formSearchParams = new URLSearchParams(formData);

      // Preserve existing URL filter parameters (e.g. metal/shape from landing page)
      // when those filters are not present in the current form (hidden / locked facets).
      searchParamsInitial.forEach((value, key) => {
        if (!formSearchParams.has(key) && key.startsWith("filter.")) {
          formSearchParams.append(key, value);
        }
      });

      const view = searchParamsInitial.toString().includes("view=select-ring")
        ? "&view=select-ring"
        : "";

      const queryParams = Object.fromEntries(formSearchParams);
      let collectionShapeValue = "no-shape-selected";

      if (queryParams["filter.p.m.custom.shape"]) {
        const shapeValue = queryParams["filter.p.m.custom.shape"].toLowerCase();
        collectionShapeValue = shapeValue;

        fetch("/cart.js", {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;",
          },
          body: JSON.stringify({ attributes: { tempShape: shapeValue } }),
        });

        document
          .querySelector("#CollectionProductGrid")
          .setAttribute("data-shape", collectionShapeValue);
      }

      this.renderPage(formSearchParams.toString() + view, event);
      return;
    } else if (this.searchTemplate) {
      const activeTypes = document.querySelector("#page-type-input").value;
      const types = activeTypes.split(",");
      const defaultTypes = document.querySelector(
        '#search-wrapper input[name="type"]',
      );

      if (!activeTypes) {
        document.querySelector("#page-type-input").value = defaultTypes.value;
      }

      formData.append("q", searchParamsInitial.get("q"));

      if (
        (types.includes("article") && !types.includes("product")) ||
        (types.includes("page") && !types.includes("product"))
      ) {
        document
          .querySelectorAll(
            `#${this.filterFormsId} input:not(#page-type-input)`,
          )
          .forEach((item) => {
            item.setAttribute("disabled", "disabled");
          });

        document
          .querySelectorAll(
            `#${this.filterFormsId} label:not(.collection-filters__label)`,
          )
          .forEach((label) => {
            label.classList.add("facet-checkbox--disabled");
          });

        [
          "filter.p.product_type",
          "filter.p.vendor",
          "filter.v.availability",
        ].forEach((param) => {
          if (searchParamsInitial.has(param)) {
            formData.delete(param);
            this.renderPage(
              new URLSearchParams(window.location.search).toString(),
              event,
            );
          }
        });
      }

      this.renderPage(new URLSearchParams(formData).toString(), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    // console.log({ event });
    // console.log(new URLSearchParams(window.location.search));
    this.toggleActiveFacets();
    const view = new URLSearchParams(window.location.search)
      .toString()
      .includes("view=select-ring")
      ? "&view=select-ring"
      : "";

    this.renderPage(new URL(event.target.href).searchParams.toString() + view);
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || "";
    // console.log({ searchParams });
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  renderPage(searchParams, event, updateURLHash = true) {
    // document.getElementById(this.productGridId).style.opacity = 0;
    console.trace("renderPage");
    console.log({ searchParams });
    //const sectionsIds = this.sections.map((section) => section.section).join(',');
    //const url = `${window.location.pathname}?sections=${sectionsIds}&${searchParams}`;
    this.sections.forEach((section) => {
      if (this.collectionTemplate) {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        this.filterData.some(filterDataUrl)
          ? this.renderSectionFromCache(filterDataUrl, section, event)
          : this.renderSectionFromFetch(url, section, event);
      } else if (this.searchTemplate) {
        const url = `${window.location.pathname}?${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        this.filterData.some(filterDataUrl)
          ? this.renderSectionFromCache(filterDataUrl, section, event)
          : this.renderSectionFromFetch(url, section, event);
      }
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, section, event) {
    console.log("renderSectionFromFetch", section);
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];

        switch (section.id) {
          case this.productGridId:
            this.renderProductGrid(html);
            break;
          case this.filterFormsId:
            this.renderFilters(html, event);
            break;
          default:
            return;
        }
      });
  }

  renderSectionsFromFetch(url, sections, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];

        sections.forEach((section) => {
          switch (section.id) {
            case this.productGridId:
              this.renderProductGrid(html);
              break;
            case this.filterFormsId:
              this.renderFilters(html, event);
              break;
            default:
              return;
          }
        });
      });
  }

  renderSectionFromCache(filterDataUrl, section, event) {
    const html = this.filterData.find(filterDataUrl).html;
    switch (section.id) {
      case this.productGridId:
        this.renderProductGrid(html);
        break;
      case this.filterFormsId:
        this.renderFilters(html, event);
        break;
      default:
        return;
    }
  }

  renderSectionsFromCache(filterDataUrl, sections, event) {
    const html = this.filterData.find(filterDataUrl).html;
    sections.forEach((section) => {
      switch (section.id) {
        case this.productGridId:
          this.renderProductGrid(html);
          break;
        case this.filterFormsId:
          this.renderFilters(html, event);
          break;
        default:
          return;
      }
    });
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById(this.productGridId).innerHTML;

    document.getElementById(this.productGridId).innerHTML = innerHTML;
    document
      .querySelector(`#${this.productGridId}`)
      .classList.remove("loading");
    // document.getElementById(this.productGridId).style.opacity = 1;
    // setTimeout(() => {
    // }, 2000);
    /* Loop over all product grid items and attach hover and mouseout listener on them */
    var allProducts = document.querySelectorAll(
      "#" + this.productGridId + " article.indiv-product",
    );
    allProducts.forEach((product) => {
      handleVariantHover(product.getAttribute("id"));
    });
    //debugger;
    //const event = new CustomEvent('paginate');
    //document.dispatchEvent(event);
  }

  renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      `#${this.filterFormsId} .js-filter`,
    );
    const matchesIndex = (element) =>
      element.dataset.index ===
      event?.target.closest(".js-filter")?.dataset.index;
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    this.renderActiveFacets(parsedHTML);

    if (countsToRender)
      this.renderCounts(countsToRender, event.target.closest(".js-filter"));
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    this.bindActiveFacetButtonEvents();
    this.toggleActiveFacets(false);
  }

  renderMobileElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
    ];

    mobileElementSelectors.forEach((selector) => {
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("CollectionFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  renderCounts(source, target) {
    const countElementSelectors = [".count-bubble", ".facets__selected"];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML =
          source.querySelector(selector).outerHTML;
      }
    });
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.addEventListener("click", this.onActiveFilterClick, {
        once: true,
      });
    });
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  getSections() {
    return [
      {
        id: this.productGridId,
        section: document.getElementById(this.productGridId).dataset.sectionId,
      },
      {
        id: this.filterFormsId,
        section: document.getElementById("main-collection-filters").dataset.id,
      },
    ];
  }
}

customElements.define("collection-filtering-form", CollectionFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", "0");
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range-selector", PriceRange);

class PageType extends HTMLElement {
  constructor() {
    super();
    this.selector = document.querySelector("[data-page-type-selector]");
    this.selector.addEventListener("change", this.setValue);
  }

  setValue(e) {
    const selectedTypes = e.currentTarget.querySelectorAll("input:checked");
    const types = Array.from(selectedTypes)
      .map((option) => option.value)
      .join(",");

    const typeInput = document.querySelector("#page-type-input");
    typeInput.value = types;

    const event = new Event("input");
    typeInput.closest("form").dispatchEvent(event);
  }
}

customElements.define("page-type-selector", PageType);
